export default "__VITE_ASSET__CmBzpKye__"